import { CustomerService } from "./CustomerService";

export class CustomerServices {
  customers: CustomerService;

  constructor() {
    this.customers = new CustomerService();
  }
}
